import axios from "axios";

const {
  REACT_APP_BASE_URL_LOCAL_SAJJAD,
  REACT_APP_BASE_URL_DEV,
  REACT_APP_BASE_URL,
  REACT_APP_BASE_URL_LOCAL_AMIR,
} = process.env;

export default axios.create({
  // baseURL: "http://192.168.3.60:8585/v2/",
  baseURL: "https://api.chortke.app/v2/",
  timeout: 3000000,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
    "Pragma": "no-cache",
  },
});
